export const fitPosterImage = (sourceWidth, sourceHeight, boxWidth, boxHeight) => {
  const scale = Math.min(boxWidth / sourceWidth, boxHeight / sourceHeight)
  return { width: sourceWidth * scale, height: sourceHeight * scale }
}

export const rpDateLabel = (date) => {
  if (!date) return 'Date RP indisponible'
  const parts = [`An ${date.year}`, `mois ${date.month}`]
  if (date.playday != null) parts.push(`playday ${date.playday}`)
  return parts.join(' · ')
}

export const niceScaleDistance = (viewportKm) => {
  if (!Number.isFinite(viewportKm) || viewportKm <= 0) return null
  const target = viewportKm / 5
  const power = 10 ** Math.floor(Math.log10(target))
  const factor = [1, 2, 5, 10].find((value) => value * power >= target) || 10
  return factor * power
}

export const haversineKm = (a, b) => {
  const rad = (degrees) => degrees * Math.PI / 180
  const dLat = rad(b.lat - a.lat)
  const dLon = rad(b.lng - a.lng)
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLon / 2) ** 2
  return 6371 * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x))
}
